module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '职级充值',
      "pop": true
    }
  }, [_c('z-backForm', {
    attrs: {
      "name": 'back-add-rank',
      "align": true
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backset
    }
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU名称")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.bu_id),
      expression: "sub.bu_id"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sub.bu_id),
      callback: function($$v) {
        _vm.$set(_vm.sub, "bu_id", $$v)
      },
      expression: "sub.bu_id"
    }
  }, _vm._l((_vm.bu_list), function(item) {
    return _c('z-limitOption', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.bu_name
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("操作类型")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.type),
      expression: "sub.type"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeRemark
    },
    model: {
      value: (_vm.sub.type),
      callback: function($$v) {
        _vm.$set(_vm.sub, "type", $$v)
      },
      expression: "sub.type"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "value": item.val,
        "label": item.label
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("职级数量")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.num),
      expression: "sub.num"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal number",
      "placeholder": "请输入职级数量"
    },
    model: {
      value: (_vm.sub.num),
      callback: function($$v) {
        _vm.$set(_vm.sub, "num", $$v)
      },
      expression: "sub.num"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("级")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item area"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("备注")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ('备注'),
      expression: "'备注'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.remark),
      expression: "sub.remark"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sub.remark),
      expression: "sub.remark"
    }],
    attrs: {
      "rule": "reason describe_limit",
      "placeholder": "请输入备注"
    },
    domProps: {
      "value": (_vm.sub.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sub, "remark", $event.target.value)
      }
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-38642623!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/finance/page-rank-recharge-add.vue
// module id = 725
// module chunks = 1